export default {
  office: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Ufficio e studio',
    hero: {
      eyebrow: 'Ufficio e studio',
      title: 'Sorveglianza discreta per ambienti di lavoro',
      lead: 'Reception, corridoi, aree sensibili: pianifichiamo sistemi di telecamere che proteggono senza inquietare dipendenti o pazienti.',
    },
    areas: {
      title: 'Aree di impiego in uffici e studi',
      lead: 'Uffici e studi moderni richiedono sicurezza discreta. Integriamo le telecamere in modo sottile nell’architettura.',
      items: {
        '0': { title: 'Reception', desc: 'La prima impressione e il primo punto di sorveglianza. Le telecamere alla reception documentano i visitatori e proteggono l’accesso.' },
        '1': { title: 'Corridoi', desc: 'I corridoi lunghi sono spesso angoli ciechi. Telecamere da soffitto compatte chiudono le lacune senza farsi notare.' },
        '2': { title: 'Sale riunioni', desc: 'Non ogni riunione va registrata. Configuriamo le telecamere per riprendere solo le aree rilevanti.' },
        '3': { title: 'Sala server', desc: 'La stanza dove risiedono i tuoi dati merita attenzione. Accesso e attività vengono registrati in modo affidabile.' },
        '4': { title: 'Accettazione studio', desc: 'Negli studi conta la discrezione. Montiamo telecamere sobrie che non inquietano i pazienti e proteggono le zone sensibili.' },
        '5': { title: 'Parcheggio e ingresso', desc: 'Parcheggi e ingressi esterni sono a rischio di notte. Telecamere resistenti con visione notturna tengono d’occhio.' },
      },
    },
    access: {
      eyebrow: 'Accesso e controllo',
      title: 'Chi può vedere cosa?',
      lead: 'Un sistema di telecamere in ufficio è accettato solo se i diritti sono chiari. Configuriamo diritti differenziati e documentiamo ogni uso.',
      items: {
        '0': { title: 'Gestione utenti', desc: 'Ogni persona riceve esattamente i diritti di cui ha bisogno, dalla vista live alla riproduzione.' },
        '1': { title: 'Mascheramento privacy', desc: 'Aree come sale pausa o spogliatoi vengono nascoste tecnicamente, in telecamera o registratore.' },
        '2': { title: 'Registro eventi', desc: 'Chi ha visto cosa e quando? Un registro di accesso completo garantisce un controllo tracciabile.' },
      },
    },
    privacy: {
      eyebrow: 'Protezione dei dati',
      title: 'Protezione dei dati sul posto di lavoro',
      lead: 'Dipendenti e visitatori godono di una protezione speciale. Implementiamo la sorveglianza in modo conforme e corretto, e ti consigliamo sulla documentazione della necessità.',
      list: {
        '0': 'Registrare solo dove operativamente necessario',
        '1': 'Segnaletica per dipendenti e visitatori',
        '2': 'Nessuna sorveglianza di spogliatoi, servizi o sale pausa',
        '3': 'Accesso alle registrazioni solo a persone autorizzate',
        '4': 'Documentazione della necessità operativa',
      },
      note: 'Nota: la sorveglianza dei luoghi di lavoro è soggetta a rigorosi requisiti legali. Ti consigliamo tecnicamente, senza sostituire la consulenza legale.',
    },
    cta: {
      title: 'Discreto. Rispettoso della privacy. Affidabile.',
      lead: 'Pianifichiamo il tuo sistema per ufficio o studio affinché protegga senza disturbare. Senza impegno e con trasparenza.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
};